import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';
import API from '../../utils/api';
import toast from 'react-hot-toast';

const STATUSES = ['placed','confirmed','processing','shipped','out_for_delivery','delivered','cancelled'];
const statusColor = { placed:'#F57F17',confirmed:'#1565C0',processing:'#6A1B9A',shipped:'#0277BD',out_for_delivery:'#00695C',delivered:'#2E7D32',cancelled:'#C62828' };

export default function AdminOrders() {
  const [orders,  setOrders]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter,  setFilter]  = useState('');
  const navigate = useNavigate();

  const load = () => {
    const q = filter ? `?status=${filter}` : '';
    API.get(`/orders${q}`).then(r => setOrders(r.data.orders || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, [filter]);

  const updateStatus = async (id, status) => {
    try { await API.put(`/orders/${id}/status`, { status }); toast.success('Status updated'); load(); }
    catch { toast.error('Update failed'); }
  };

  return (
    <AdminLayout title="Orders Management">
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {['', ...STATUSES].map(s => (
          <button key={s} onClick={() => setFilter(s)}
            style={{ padding: '6px 14px', borderRadius: 20, border: '1px solid var(--border)', fontSize: 12, cursor: 'pointer', textTransform: 'capitalize', background: filter === s ? 'var(--maroon)' : 'white', color: filter === s ? 'white' : 'var(--text-mid)' }}>
            {s || 'All'}
          </button>
        ))}
      </div>
      {loading ? <div className="spinner" /> : (
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', border: '1px solid var(--border)', borderRadius: 4 }}>
          <thead>
            <tr style={{ background: 'var(--cream)' }}>
              {['Order','Date','Customer','Amount','Payment','Status','Action'].map(h => (
                <th key={h} style={{ padding: '12px 16px', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--text-light)', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: 32, textAlign: 'center', color: 'var(--text-light)' }}>No orders found</td></tr>
            ) : orders.map(o => (
              <tr key={o._id} style={{ borderBottom: '1px solid var(--border)' }}>
             <td style={{ padding: '12px 16px', fontSize: 14, fontWeight: 500 }}>
  <button
    onClick={() => navigate(`/admin/orders/${o._id}`)}
    style={{
      background: 'none',
      border: 'none',
      color: 'var(--maroon)',
      fontWeight: 600,
      cursor: 'pointer',
      fontSize: 14,
      padding: 0,
    }}
  >
    #{o.orderId}
  </button>
</td>
                <td style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text-light)' }}>{new Date(o.createdAt).toLocaleDateString('en-IN')}</td>
                <td style={{ padding: '12px 16px', fontSize: 14 }}>{o.user?.name || o.guestName || 'Guest'}</td>
                <td style={{ padding: '12px 16px', fontSize: 14, color: 'var(--maroon)', fontWeight: 500 }}>₹{o.totalAmount?.toLocaleString()}</td>
                <td style={{ padding: '12px 16px', fontSize: 13, textTransform: 'capitalize' }}>{o.paymentMethod}</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 10, background: `${statusColor[o.orderStatus]}22`, color: statusColor[o.orderStatus] || '#555', textTransform: 'capitalize' }}>
                    {o.orderStatus}
                  </span>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <select defaultValue={o.orderStatus} onChange={e => updateStatus(o._id, e.target.value)}
                    style={{ border: '1px solid var(--border)', borderRadius: 2, padding: '4px 8px', fontSize: 12, background: 'var(--ivory)' }}>
                    {STATUSES.map(s => <option key={s} value={s} style={{ textTransform: 'capitalize' }}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </AdminLayout>
  );
}
